import web from "../src/images/s1.jpg";
import app from "../src/images/app.jpeg";
import android from "../src/images/android.jpeg";
import digital from "../src/images/digital.jpeg";
import marketing from "../src/images/marketing.jpg";
import software from "../src/images/software.jpeg";

const Sdata = [
  {
    imgsrc: web,
    content: "Is your website not generating enough leads? We can help you with that",
    title: "web development",
    cta: "Let's review your needs and see how we can help",
  },
  {
    imgsrc: app,
    content: "Have you maximized your app's potential? We can help you with that",
    title: "App development",
    cta: "Let's review your needs and see how we can help",
  },
  {
    imgsrc: software,
    title: "Software development",
    content: "Are you ready for the future of software development? We can help you with that",
    cta: "Let's review your needs and see how we can help",
  },
  {
    imgsrc: digital,
    title: "Digital Marketing",
    content: "Are your Marketing dollars being tracked and measured? We can help you with that",
    cta: "Let's review your needs and see how we can help",
  },
  {
    imgsrc: android,
    title: "Android development",
    content: "Does your Android app need a makeover? We can help you with that",
    cta: "Let's review your needs and see how we can help",
  },
  {
    imgsrc: marketing,
    title: "Marketing",
    content: "Are your online Marketing efforts not yielding results? We can help you with that",
    cta: "Let's review your needs and see how we can help",
  },
];

export default Sdata;
